@import '../styles/palette.scss';
@import '../styles/fonts.scss';
@import '../styles/mixins.scss';

.selectroleContainer {
  display: flex;
  height: 100%;
  justify-content: center;
  margin: 15% auto auto;
  width: 100%;

  .header {
    margin: 2em;
    text-align: center;
  }

  div {
    margin-right: 0.125rem;
  }
}
